/**
 * strive-pdp.js  (rev 11 — self-contained size guide modal)
 *
 * ROOT CAUSE FIXED (size guide): the modal markup previously relied on
 * Dawn's <modal-dialog>/<modal-opener> custom elements, but no JS here
 * ever wired up open/close behaviour, and no CSS defined the modal's
 * shown/hidden states. initSizeGuideModal() below is fully
 * self-contained — open, close-via-X, close-via-backdrop, and
 * close-via-Escape are all handled directly, no dependency on Dawn.
 */

(function () {
  'use strict';

  var TEXT_DISABLED  = 'SELECT A SIZE TO CONTINUE';
  var TEXT_ENABLED   = 'ADD TO CART';
  var TEXT_SOLD_OUT  = 'SOLD OUT';
  var TEXT_UNAVAIL   = 'UNAVAILABLE';
  var EM_DASH        = '\u2014';
  var MID_DOT        = '\u00B7';

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getVariantPicker() {
    return qs('variant-radios, variant-selects');
  }

  function findFieldset(picker, pattern) {
    if (!picker) return null;
    var fieldsets = qsa('fieldset', picker);
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = qs('legend', fieldsets[i]);
      if (legend && pattern.test(legend.textContent.trim())) return fieldsets[i];
    }
    return null;
  }

  function getSizeFieldset() {
    var picker = getVariantPicker();
    var fs = findFieldset(picker, /size/i);
    if (fs) return fs;
    var r = picker && qs('input[type="radio"][name*="ize"]', picker);
    return r ? r.closest('fieldset') : null;
  }

  function getColourFieldset() {
    var picker = getVariantPicker();
    var fs = findFieldset(picker, /colou?r|couleur|farbe|kleur/i);
    if (fs) return fs;
    var all = picker ? qsa('fieldset', picker) : [];
    var sf  = getSizeFieldset();
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== sf) return all[i];
    }
    return null;
  }

  function sizeIsSelected(sf) {
    return !!(sf && qs('input[type="radio"]:checked', sf));
  }

  function deselectSize(sf) {
    if (!sf) return;
    qsa('input[type="radio"]', sf).forEach(function (r) { r.checked = false; });
  }

  function selectedColourLabel(colourFieldset) {
    if (!colourFieldset) return '';
    var checked = qs('input[type="radio"]:checked', colourFieldset);
    return checked ? checked.value : '';
  }

  function formatMoney(subunits) {
    var amount  = subunits / 100;
    var priceEl = qs('.price-item--regular, .price__regular .price-item');
    var raw     = priceEl ? priceEl.textContent.trim() : '';
    var symbol  = raw.replace(/[\d\s,.]+.*/, '') || '£';
    return symbol + amount.toFixed(2);
  }

  function readRawPrice() {
    var idInput = qs('form[action="/cart/add"] [name="id"], product-form form [name="id"]');
    if (idInput) {
      var attr = idInput.getAttribute('data-price');
      if (attr && !isNaN(parseInt(attr, 10))) return parseInt(attr, 10);
    }
    if (window.variantData) {
      try {
        var variants = typeof window.variantData === 'string'
          ? JSON.parse(window.variantData) : window.variantData;
        var sel = idInput && idInput.value;
        if (sel) {
          var v = variants.find(function (x) { return String(x.id) === String(sel); });
          if (v && v.price) return v.price;
        }
      } catch (e) {}
    }
    var el = qs('.price--large .price-item--regular, .price-item--regular');
    if (el) {
      var num = parseFloat(el.textContent.replace(/[^\d.]/g, ''));
      if (!isNaN(num)) return Math.round(num * 100);
    }
    return null;
  }

  function readQty() {
    var q = qs('.quantity__input, input[name="quantity"]');
    if (!q) return 1;
    var v = parseInt(q.value, 10);
    return (isNaN(v) || v < 1) ? 1 : v;
  }

  function computeTotal() {
    var unit = readRawPrice();
    return unit ? formatMoney(unit * readQty()) : null;
  }

  function productTitle() {
    var h1 = qs('.product__title h1, h1.product__title, h1');
    return h1 ? h1.textContent.trim().toUpperCase() : '';
  }

  function labelSpan(btn) {
    if (!btn) return null;
    var spans = btn.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var cl = spans[i].classList;
      if (!cl.contains('loading-overlay__spinner') &&
          !cl.contains('sold-out-message')         &&
          !cl.contains('visually-hidden')           &&
          !cl.contains('hidden')) return spans[i];
    }
    return spans[0] || null;
  }

  function normaliseDawnText(text) {
    if (!text) return TEXT_DISABLED;
    var t = text.trim().toLowerCase();
    if (t.indexOf('sold') !== -1)    return TEXT_SOLD_OUT;
    if (t.indexOf('unavail') !== -1) return TEXT_UNAVAIL;
    if (t.indexOf('stock') !== -1)   return TEXT_SOLD_OUT;
    return text.toUpperCase();
  }

  function disableMain(btn, text) {
    if (!btn) return;
    btn.setAttribute('disabled', 'disabled');
    var sp = labelSpan(btn);
    if (sp) sp.textContent = text || TEXT_DISABLED;
  }

  function enableMain(btn) {
    if (!btn) return;
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
    var price = computeTotal();
    var sp    = labelSpan(btn);
    if (sp) sp.textContent = price
      ? TEXT_ENABLED + ' ' + EM_DASH + ' ' + price
      : TEXT_ENABLED;
  }

  function disableSticky(btn) {
    if (!btn) return;
    btn.disabled    = true;
    btn.className   = 'stick-off';
    btn.textContent = TEXT_ENABLED;
  }

  function enableSticky(btn, labelEl, priceEl, colourFieldset) {
    if (!btn) return;
    btn.disabled    = false;
    btn.className   = 'stick-on';
    btn.textContent = TEXT_ENABLED;
    var price = computeTotal();
    if (priceEl && price) priceEl.textContent = price;
    if (labelEl) {
      var title  = productTitle();
      var colour = selectedColourLabel(colourFieldset).toUpperCase();
      labelEl.textContent = colour
        ? title + ' ' + MID_DOT + ' ' + colour
        : title;
    }
  }

  function disableBoth(mainBtn, stickyBtn, text) {
    disableMain(mainBtn, text);
    disableSticky(stickyBtn);
  }

  function enableBoth(mainBtn, stickyBtn, labelEl, priceEl, colourFieldset) {
    enableMain(mainBtn);
    enableSticky(stickyBtn, labelEl, priceEl, colourFieldset);
  }

  function readInventoryMap() {
    var el = qs('#strive-inventory-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function lowStockMessage(qty) {
    if (qty >= 6) return null;
    if (qty >= 3) return 'Only a few left in stock';
    if (qty >= 1) return 'Only ' + qty + ' left in stock';
    return null;
  }

  function renderBadge(indicatorEl, message) {
    indicatorEl.innerHTML =
      '<span class="strive-low-stock__dot" aria-hidden="true"></span>' +
      '<span>' + message + '</span>';
    indicatorEl.classList.add('is-visible');
  }

  function hideBadge(indicatorEl) {
    indicatorEl.classList.remove('is-visible');
    indicatorEl.innerHTML = '';
  }

  function updateLowStock(inventoryMap, variantIdInput) {
    try {
      var indicatorEl = qs('#strive-low-stock');
      if (!indicatorEl) return;

      var sizeFieldset = getSizeFieldset();

      if (!sizeIsSelected(sizeFieldset)) {
        hideBadge(indicatorEl);
        return;
      }

      var variantId = variantIdInput && variantIdInput.value;
      var data      = variantId ? inventoryMap[variantId] : null;

      if (!data || !data.tracked) {
        hideBadge(indicatorEl);
        return;
      }

      var msg = lowStockMessage(data.quantity);
      if (msg) {
        renderBadge(indicatorEl, msg);
      } else {
        hideBadge(indicatorEl);
      }
    } catch (e) {
      // never let a badge error block CTA enabling
    }
  }

  function initScroll(stickyBar, mainBtn) {
    if (!stickyBar || !mainBtn) return;
    stickyBar.style.display = 'none';
    var lastY = window.pageYOffset;
    window.addEventListener('scroll', function () {
      var currentY      = window.pageYOffset;
      var scrollingDown = currentY > lastY;
      lastY = currentY;
      var btnAboveViewport = mainBtn.getBoundingClientRect().bottom < 0;
      stickyBar.style.display = (scrollingDown && btnAboveViewport) ? 'block' : 'none';
    }, { passive: true });
  }

  /* Size guide trigger positioning is now handled server-side in
     snippets/product-variant-picker.liquid — the button renders
     next to the Size legend directly, no JS repositioning needed. */

  /* ── Self-contained size guide modal open/close ────────────────
     Does NOT use Dawn's <modal-dialog>/<modal-opener>. Open,
     close-via-X, close-via-backdrop, and close-via-Escape are all
     handled directly here.

     ROBUSTNESS: wires up EVERY element matching [id^="SizeGuideTrigger-"],
     not just the first. If the old block-loop render of this button
     hasn't been removed from main-product.liquid yet, the page will
     have two buttons sharing the same id — querySelector() would only
     attach a listener to one of them, leaving the other dead on click.
     querySelectorAll() here means both work correctly regardless.    */
  function initSizeGuideModal() { 
 function modalFor(trigger) { 
 var suffix = trigger.id.replace("SizeGuideTrigger-", ""); 
 return qs("#SizeGuideModal-" + suffix); 
 } 
 function openModal(modal, trigger) { 
 modal.classList.add("is-open"); 
 modal.setAttribute("aria-hidden", "false"); 
 document.body.classList.add("strive-size-guide-modal-open"); 
 modal._trigger = trigger; 
 var panel = qs(".strive-size-guide-panel", modal); 
 panel && panel.focus(); 
 } 
 function closeModal(modal) { 
 modal.classList.remove("is-open"); 
 modal.setAttribute("aria-hidden", "true"); 
 document.body.classList.remove("strive-size-guide-modal-open"); 
 modal._trigger && modal._trigger.focus(); 
 } 
 // Delegated open: survives variant section re-renders 
 document.addEventListener("click", function(e) { 
 var trigger = e.target.closest('[id^="SizeGuideTrigger-"]'); 
 if (trigger) { 
 var modal = modalFor(trigger); 
 modal && openModal(modal, trigger); 
 return; 
 } 
 var closeEl = e.target.closest("[data-size-guide-close]"); 
 if (closeEl) { 
 var openModalEl = closeEl.closest(".strive-size-guide-modal"); 
 openModalEl && closeModal(openModalEl); 
 } 
 }); 
 document.addEventListener("keydown", function(e) { 
 if (e.key === "Escape") { 
 var openModalEl = qs(".strive-size-guide-modal.is-open"); 
 openModalEl && closeModal(openModalEl); 
 } 
 }); 
}

  function syncState(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, variantIdInput, inventoryMap) {
    var sizeFieldset   = getSizeFieldset();
    var colourFieldset = getColourFieldset();

    if (sizeIsSelected(sizeFieldset)) {
      enableBoth(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, colourFieldset);
    } else {
      disableBoth(mainBtn, stickyBtn);
    }
    updateLowStock(inventoryMap, variantIdInput);
  }

  function init() {
    var productForm   = qs('product-form');
    var stickyBar     = qs('#sticky-add-to-cart');

    if (!productForm) return;

    var mainBtn       = qs('.product-form__submit', productForm);
    var variantId     = qs('form [name="id"]', productForm);
    var stickyBtn     = qs('#strive-sticky-btn');
    var stickyLabelEl = qs('#strive-sticky-label');
    var stickyPriceEl = qs('#strive-sticky-price');
    var qtyInput      = qs('.quantity__input, input[name="quantity"]');

    if (!mainBtn) return;

    var inventoryMap = readInventoryMap();

    deselectSize(getSizeFieldset());
    var picker = getVariantPicker();
    if (picker) {
      qsa('select', picker).forEach(function (sel) {
        if (/size/i.test(sel.name || sel.id || '')) {
          if (!sel.querySelector('option[value=""]')) {
            var opt = document.createElement('option');
            opt.value = ''; opt.textContent = 'Select a size';
            opt.setAttribute('disabled', '');
            opt.setAttribute('selected', '');
            opt.setAttribute('hidden', '');
            sel.insertBefore(opt, sel.firstChild);
          }
          sel.value = '';
        }
      });
    }

    disableBoth(mainBtn, stickyBtn);
    updateLowStock(inventoryMap, variantId);

    initScroll(stickyBar, mainBtn);
    initSizeGuideModal();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!stickyBtn.disabled) {
          var submit = qs('.product-form__submit', productForm);
          if (submit && !submit.disabled) submit.click();
        }
      });
    }

    function onQtyChange() {
      if (sizeIsSelected(getSizeFieldset())) {
        enableBoth(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, getColourFieldset());
      }
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', onQtyChange);
      qtyInput.addEventListener('input',  onQtyChange);
    }
    var qtyWrapper = qs('quantity-input');
    if (qtyWrapper) qtyWrapper.addEventListener('change', onQtyChange);

    customElements.whenDefined('product-form').then(function () {
      var proto = Object.getPrototypeOf(productForm);
      if (!proto || typeof proto.toggleSubmitButton !== 'function') return;
      var _orig = proto.toggleSubmitButton;

      productForm.toggleSubmitButton = function (disable, text) {
        try {
          _orig.call(this, disable, text);
        } catch (e) {
          // Dawn's original references a sticky submit button that
          // doesn't exist in our custom sticky markup — safe to ignore
        }

        if (disable) {
          var label = text ? normaliseDawnText(text) : TEXT_DISABLED;
          disableBoth(mainBtn, stickyBtn, label);
          updateLowStock(inventoryMap, variantId);
        } else {
          setTimeout(function () {
            var sizeFieldset = getSizeFieldset();
            if (sizeIsSelected(sizeFieldset)) {
              enableBoth(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, getColourFieldset());
            } else {
              deselectSize(sizeFieldset);
              disableBoth(mainBtn, stickyBtn);
            }
            updateLowStock(inventoryMap, variantId);
          }, 50);
        }
      };
    });

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return;

      var liveVariantPicker = getVariantPicker();
      if (!liveVariantPicker || !liveVariantPicker.contains(target)) return;

      var sizeFieldset = getSizeFieldset();
      var isInsideSize = sizeFieldset && sizeFieldset.contains(target);
      if (!isInsideSize) deselectSize(sizeFieldset);

      setTimeout(function () {
        syncState(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, variantId, inventoryMap);
      }, 80);
    });
    document.body.classList.remove('strive-loading');
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();